const openPopup = document.querySelectorAll('.open-popup');
const closePopup = document.querySelectorAll('.close-popup');

for (let i = 0; i < openPopup.length; i++) {
    openPopup[i].addEventListener('click', function(){
        openPopup[i].closest('.card__content').querySelector('.popup').classList.add('show-popup');
        openPopup[i].closest('.card__content').querySelector('.mask-popup').classList.add('show-popup');
    })
}

for (let i = 0; i < closePopup.length; i++) {
    closePopup[i].addEventListener('click', function(){
        closePopup[i].closest('.card__content').querySelector('.popup').classList.remove('show-popup');
        closePopup[i].closest('.card__content').querySelector('.mask-popup').classList.remove('show-popup');
    })
}